/*
	the "Contact Us" section shared by the Privacy Policy and the Terms of Service.

	both documents tell the reader to contact us, so both need a reachable contact method in
	the same place, worded the same way -- keeping one copy of it is the point of this file.

	Privacy and Terms are rendered from three places (static-page, settings, enter-email) and only
	two of them also mount the Contact popup, so `onOpenContact` is optional: given a way to
	open the form we link to it, and otherwise we fall back to the address the form posts to.
	The fallback is what makes this safe to drop into a parent that has no Contact modal --
	without it, that parent would render a heading with nothing under it, which is the bug
	this section exists to fix (ha-322 F2).
*/
export const contactEmailAddress = 'info@hangaround.live'

export default function ContactUsSection({ onOpenContact }: { onOpenContact?: () => void }) {
	return (
		<p>
			{onOpenContact
				? <>
					Questions, requests, or anything else? Use our{' '}
					<span
						className="text-rose-600 hover:text-rose-600/80 cursor-pointer underline"
						onClick={onOpenContact}
					>contact form</span>, or email us at{' '}
					<a className="text-rose-600 hover:text-rose-600/80 underline" href={`mailto:${contactEmailAddress}`}>
						{contactEmailAddress}
					</a>.
				</>
				: <>
					Questions, requests, or anything else? Email us at{' '}
					<a className="text-rose-600 hover:text-rose-600/80 underline" href={`mailto:${contactEmailAddress}`}>
						{contactEmailAddress}
					</a>.
				</>}
		</p>
	)
}
